<!---- Copyright The Linux Foundation and each contributor to LFX.-->
<!---- SPDX-License-Identifier: MITs -->

<div class="header-items">
  <div>
    <lfx-filter-chips
      *ngIf="chipsOptions && chipsOptions.length"
      class="mb-4 mt-4"
      [(ngModel)]="selectedFilterItem"
      [chips]="chipsOptions"
    ></lfx-filter-chips>
  </div>
  <div>
    <lfx-date-range-dropdown [style]="'small'" [selectedItem]="initialTimeRange || 'last_12mo'" (selectDateRange)="updateTimeRange($event)"></lfx-date-range-dropdown>
  </div>
</div>
<lfx-profile-snapshot-employee-technical
  *ngIf="selectedFilterItem.id === 'Technical'"
  [timeRange$]="timeRange$"
  [userId]="userId"
></lfx-profile-snapshot-employee-technical>
  <lfx-profile-snapshot-employee-events
  *ngIf="selectedFilterItem.id === 'Events'"
  [timeRange$]="timeRange$"
  [userId]="userId"
  [projectId]="projectId"
></lfx-profile-snapshot-employee-events>
<lfx-profile-snapshot-employee-training
  *ngIf="selectedFilterItem.id === 'Training'"
  [timeRange$]="timeRange$"
  [userId]="userId"
></lfx-profile-snapshot-employee-training>
<lfx-profile-snapshot-employee-meetings
  *ngIf="selectedFilterItem.id === 'Meetings'"
  [timeRange$]="timeRange$"
  [userId]="userId"
></lfx-profile-snapshot-employee-meetings>
<lfx-profile-snapshot-employee-subscriptions
  *ngIf="selectedFilterItem.id === 'Subscriptions'"
  [timeRange$]="timeRange$"
  [userId]="userId"
></lfx-profile-snapshot-employee-subscriptions>
